import React, { useRef } from 'react';
import { useEffect, useState } from 'react';
import storyImage from './../../assets/images/stor/story-01.jpg';
const Story = () => {
  const [imageData, setImageData] = useState(null);
    const [error, setError] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:74/api/v1";
    const BASE_URL = API_URL.replace('/api/v1', '');
    useEffect(() => {
        fetch(`${API_URL}/settings/about_image`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data) && data.length > 0 && data[0].value) {
                    setImageData(data[0]);
                } else {
                    setError("No image found in response.");
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
                setError("Error fetching image.");
            });
    }, []);

    if (error) {
        return <div className="text-danger text-center p-4">Error: {error}</div>;
    }

    if (!imageData) {
        return <div className="text-center p-4">Loading...</div>;
    }
  return (
    <section className="story">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="story-content">
              <p align="justify">We are more than just a workspace we are a partner in your entrepreneurial journey. We understand the unique needs of entrepreneurs, founders, and startup visionaries who are driven to build something extraordinary.<br />
                While we grow, we want you to grow. Our mission is to support you in building and developing your business by providing a vibrant community where innovation thrives, connections are made, and success stories are written.<br />
                Let’s grow together !
              </p>
            </div>
          </div>
          <div className="col-lg-6">
          <img
                    src={imageData?.value ? `${BASE_URL}/upload/about/${imageData.value}` : storyImage}
                    alt="About"
                    className="rounded img-fluid"
                    style={{ maxWidth: '100%' }}
                    onError={(e) => { e.target.src = {storyImage} }}
                />
            {/* <Slider {...settings} className="story-slider">
              <div className="slider-item">
                <img
                    src={imageData?.value ? `${BASE_URL}/upload/about/${imageData.value}` : storyImage}
                    alt="About"
                    className="rounded img-fluid"
                    style={{ maxWidth: '100%' }}
                    onError={(e) => { e.target.src = {storyImage} }}
                />
              </div>
              <div className="slider-item">
                <img
                    src={imageData?.value ? `${BASE_URL}/upload/about/${imageData.value}` : storyImage}
                    alt="About"
                    className="rounded img-fluid"
                    style={{ maxWidth: '100%' }}
                    onError={(e) => { e.target.src = {storyImage} }}
                />
              </div>
              <div className="slider-item">
                <img
                    src={imageData?.value ? `${BASE_URL}/upload/about/${imageData.value}` : storyImage}
                    alt="About"
                    className="rounded img-fluid"
                    style={{ maxWidth: '100%' }}
                    onError={(e) => { e.target.src = {storyImage} }}
                />
              </div>
            </Slider> */}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Story;